import React from 'react';
import PropTypes from 'prop-types';
import { daysUntilDate } from '../../utilities';

import Button from 'Components/Button';
import SubscriptionPlanInfo from 'Containers/SubscriptionPlanInfo';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import styles from './TrialActivationBanner.scss';
import { ROUTES } from 'Settings/route-strings';

// We want to use this for teachers as a 'how are we doing'
// banner. We’re not, yet.
const EmojiButton = ({ emoji, clickHandler }) => (
  <Button
    buttonType="primary-mono"
    additionalClasses=" Button--giant-emoji"
    label={emoji}
    clickHandler={clickHandler}
    blurOnClick
    style={{
      display: 'inline-block',
      margin: '0 0.125em',
    }}
  />
);

const TrialActivationBanner = ({ activeUser }) => {
  if (activeUser.isStudent) return null;
  return (
    <SubscriptionPlanInfo
      render={({ plan, license }) => {
        if (!plan.availableUpgrade) return null;
        const days = daysUntilDate(new Date(license.end_time), true);
        const daysLeft = (
          <ConnectedFormattedMessage
            id="trial_activation_banner.trial_remaining_count"
            values={{
              result_count: days,
            }}
          />
        );
        if (activeUser.isAdmin)
          return (
            <div className="TrialActivationBanner" data-is-admin>
              <div className="TrialActivationBanner__content">
                <div className="TrialActivationBanner__remaining">
                  <div className="TrialActivationBanner__days-label">
                    <ConnectedFormattedMessage id="trial_activation_banner.trial_remaining_text" />
                  </div>
                  <div className="TrialActivationBanner__days">{daysLeft}</div>
                </div>
                <div className="TrialActivationBanner__headline">
                  <ConnectedFormattedMessage id="trial_activation_banner.headline" />
                </div>
                <div className="TrialActivationBanner__action">
                  <Button
                    buttonType="primary-mono"
                    additionalClasses=" Button--fit-content"
                    label={
                      <ConnectedFormattedMessage id="trial_activation_banner.button_label" />
                    }
                    route={ROUTES.SETTINGS_SUBSCRIPTION_PAYMENT}
                  />
                </div>
              </div>
            </div>
          );
        return (
          <div className="TrialActivationBanner" data-is-admin={false}>
            <div className="TrialActivationBanner__content">
              <div className="TrialActivationBanner__headline">
                <div className="TrialActivationBanner__days">{daysLeft}</div>
                <ConnectedFormattedMessage id="trial_activation_banner.trial_remaining_text" />
              </div>
            </div>
          </div>
        );
      }}
    />
  );
};

EmojiButton.propTypes = {
  clickHandler: PropTypes.func.isRequired,
  emoji: PropTypes.string.isRequired,
};

TrialActivationBanner.propTypes = {
  activeUser: PropTypes.object.isRequired,
};

export default TrialActivationBanner;
